import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MStaticClient, MStaticInter } from '@argalis-apps/models';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';

@Component({
  selector: 'argalis-apps-static-ca-card',
  templateUrl: './ca-card.component.html',
  styleUrls: ['./ca-card.component.scss']
})
export class CaCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input('caData')
  set _caData(value: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo) {
    this.caData = value;
  }
  @Input('isInter')
  set _isInter(value: boolean) {
    this.isInter = value;
  }
  @Input('indicator')
  set _indicator(value: boolean) {
    this.indicator = value;
  }
  public isInter: boolean;
  public indicator: boolean;
  public caData: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
  public headerBackground = 'uk-background-muted';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';

  constructor(private accountConfigService: AccountConfigService) {}

  parseToNumber(ca: number | MStaticInter.ICa, nbApp?: number): number {
    if (nbApp) {
      if (!isNaN(Number(ca))) {
        return Number(Number(ca) / nbApp) || 0;
      } else if (ca instanceof MStaticInter.CCa) {
        return Number(ca.prixGlobal / nbApp) || 0;
      }
    } else {
      if (!isNaN(Number(ca))) {
        return Number(ca) || 0;
      } else if (ca instanceof MStaticInter.CCa) {
        return Number(ca.prixGlobal) || 0;
      }
    }
    return null;
  }
  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
